import React from "react";

const Principles: React.FC = () => {
  return (
    <section className="principles">
      <div className="principles__grid">
        <div className="principle">
          <i className="fa-solid fa-people-group" aria-hidden="true" />
          <div>
            <strong>Locally recommended</strong>
            <span>Picked by people who live and eat here. No paid placements.</span>
          </div>
        </div>
        <div className="principle">
          <i className="fa-solid fa-map-location-dot" aria-hidden="true" />
          <div>
            <strong>Pinned on a map</strong>
            <span>Filter, sort, and walk straight to the right stall.</span>
          </div>
        </div>
        <div className="principle">
          <i className="fa-solid fa-wallet" aria-hidden="true" />
          <div>
            <strong>Price-marked</strong>
            <span>Know what you will pay before you sit down.</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Principles;